<!--
 * @Description:
 * @Author: cxh
 * @Date: 2022-05-010 09:55:14
 * @LastEditTime: 2023-06-06 16:09:26
 * @LastEditors: cxh
-->
<template>
  <div class="base-editor" v-if="!disabled">
    <Toolbar style="border-bottom: 1px solid #d8dfe4" :editor="editorRef" :defaultConfig="toolbarConfig" :mode="mode" />
    <Editor
      style="height: 200px; overflow-y: hidden"
      v-model="valueHtml"
      :defaultConfig="{
        placeholder: placeholderComputed,
        ...editorConfig
      }"
      :mode="mode"
      @onCreated="handleCreated"
      @onChange="handleChange"
      @onBlur="handleBlur"
    />
  </div>
  <div v-else class="disabledTxt">
    <div v-html="valueHtml"></div>
  </div>
  <div
    :style="{ width: '200px', position: 'fixed', top: flexXY.top + 'px', left: flexXY.left + 'px' }"
    class="UserSelect"
  >
    <div v-if="autofocus">
      <UserSelect
        v-model:value="dutyBy"
        :placeholder="$t('common.pleaseSelect')"
        allowClear
        :open="true"
        ref="userSelectRef"
        @select="insertMention"
      />
    </div>
  </div>
</template>
<script lang="ts">
import '@wangeditor/editor/dist/css/style.css' // 引入 css
import { onBeforeUnmount, onMounted, computed, ref, shallowRef, watch } from 'vue'
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import { IDomEditor, Boot, i18nChangeLanguage, IToolbarConfig } from '@wangeditor/editor'
import mentionModule, { MentionElement } from '@wangeditor/plugin-mention'
import { Form } from 'ant-design-vue'
import xss from 'xss'
import { useI18n } from 'vue-i18n'
import { useInteractionStore } from '@/stores/interaction'
export default { name: 'Editor' }
</script>
<script lang="ts" setup>
const { t } = useI18n()
Boot.registerModule(mentionModule)
const editorRef = shallowRef()
// 内容 HTML
const dutyBy = ref('')
const userSelectRef = ref()
const flexXY = ref({
  top: 100,
  left: 2
})
const valueHtml = ref('')
const prevHtml = ref('')
const autofocus = ref(false)
const props = defineProps({
  value: {
    type: String,
    default: ''
  },
  mode: {
    type: String,
    default: 'default'
  },
  mention: {
    type: Array
  },
  maxlength: {
    type: Number
  },
  action: {
    type: String,
    default: '/api/admin/v1/storage/shareUpload'
  },
  placeholder: String,
  disabled: Boolean
})
const shareInfo = useInteractionStore()
const emit = defineEmits(['update:value', 'update:mention'])
const formItemContext = Form.useInjectFormItemContext()
const placeholderComputed = computed(() => {
  if (props.placeholder) {
    return props.placeholder
  }
  return `1. ${t('follow.process')}<br />2. ${t('follow.result')}<br />3. ${t('follow.follow-up')}<br />4. ${t(
    'follow.problemsAndHelp'
  )}`
})
// 富文本空值票判断
const checkVal = (str: string) => {
  let num = 0
  const reg = /<p>(&nbsp;|&nbsp;\s+)+<\/p>|<p>(<br>)+<\/p>/g
  while (num < str.length && str !== '') {
    num++
    const k = str.match(reg)
    if (k) {
      str = str.replace(k[0], '')
    }
  }
  return str === ''
}
watch(
  () => props.value,
  (v, prev) => {
    if (v && v !== valueHtml.value) {
      valueHtml.value = xss(v)
    } else if (!v && editorRef.value) {
      editorRef.value.clear()
      emit('update:mention', [])
    }
  }
)

const toolbarConfig: Partial<IToolbarConfig> = {
  toolbarKeys: ['emotion']
}
const hideModal = () => {
  autofocus.value = false
}
// 显示弹框
const showModal = (editor: IDomEditor) => {
  // 获取光标位置，定位 modal
  const domSelection: any = document.getSelection()
  const domRange = domSelection.getRangeAt(0)
  if (domRange == null) return
  const selectionRect = domRange.getBoundingClientRect()
  flexXY.value = {
    left: selectionRect.left,
    top: selectionRect.top
  }
  dutyBy.value = ''
  // editorRef.value.blur()
  setTimeout(() => {
    autofocus.value = true
  }, 100)
  setTimeout(() => {
    userSelectRef.value?.focus()
  }, 300)

  // 显示 modal 弹框，并定位
  // PS：modal 需要自定义，如 <div> 或 Vue React 组件
}
// 当触发某事件（如点击一个按钮）时，插入 mention 节点
function insertMention(v: any, option: any) {
  const user = userSelectRef.value.getValueObj(v)
  if (!user) {
    return
  }
  const mentionNode: MentionElement = {
    type: 'mention', // 必须是 'mention'
    value: `${user.userName}(${user.employeeNo})`, // 文本
    info: 'mentionByemployeeNo' + user.employeeNo + 'mentionByemployeeNo', // 其他信息，自定义
    children: [{ text: '' }] // 必须有一个空 text 作为 children
  }
  editorRef.value.restoreSelection() // 恢复选区
  editorRef.value.deleteBackward('character') // 删除 '@'
  editorRef.value.insertNode(mentionNode) // 插入 mention
  editorRef.value.move(1) // 移动光标
}
const editorConfig = {
  // placeholder: placeholder.value,
  autoFocus: false,
  EXTEND_CONF: {
    mentionConfig: {
      showModal, // 必须
      hideModal // 必须
    }
  }
}
// 组件销毁时，也及时销毁编辑器
onBeforeUnmount(() => {
  const editor = editorRef.value
  if (editor == null) return
  editor.destroy()
})
const handleCreated = (editor: IDomEditor) => {
  editorRef.value = editor // 记录 editor 实例，重要！
}
const setMention = () => {
  // 处理@
  let userCodes: any = []
  // const myreg = /(?<=mentionByemployeeNo).*?(?=mentionByemployeeNo)/g
  const myreg = /mentionByemployeeNo(.*?)mentionByemployeeNo/g
  userCodes = valueHtml.value.match(myreg)
  if (!userCodes) {
    userCodes = []
  }
  const mention: any = []
  userCodes.forEach((item: any) => {
    mention.push(item.replaceAll('mentionByemployeeNo', ''))
  })
  emit('update:mention', mention)
}
const handleChange = (editor: IDomEditor) => {
  if (valueHtml.value === props.value) {
    return
  }
  if (props.maxlength && editor.getText().length > props.maxlength && !prevHtml.value) {
    prevHtml.value = valueHtml.value
    return
  }
  let result = valueHtml.value
  if (checkVal(valueHtml.value)) {
    result = ''
  }
  emit('update:value', result)
  setMention()
  formItemContext.onFieldChange()
}
const handleBlur = (editor: IDomEditor) => {
  if (props.maxlength && valueHtml.value.length > props.maxlength) {
    editor.setHtml(prevHtml.value)
  }
}
onMounted(() => {
  if (shareInfo.language === 'en-US') {
    i18nChangeLanguage('en')
  } else {
    i18nChangeLanguage('zh-CN')
  }
})
</script>

<style scoped lang="scss">
.base-editor {
  border: 1px solid #d8dfe4;
  border-radius: 2px;
  position: relative;
}
.disabledTxt {
  min-height: 54px;
  width: 100%;
  padding: 11px 0;
}
</style>
<style>
.w-e-text-placeholder {
  font-style: normal;
}
</style>
